<template>
	<div id="app" class="background-div">
		<nav-bar
			@menu-button-click="toggleSideBar"
			@change-max-width="updateSideBarMaxWidth"
			:showBackButton="showBackButton"
			@back-button-click="goBack"
		/>
		<side-bar
			:hidden="sideBarHidden || noPermission"
			:max-width="sideBarMaxWidth"
			@link="sideBarLinkClicked"
			:links="parsedLinks"
			@resize="sideBarResized"
			:sideBarOnlyExpanded="sideBarOnlyExpanded"
			v-click-outside="onClickOutside"
		/>
		<router-view/>
		<vue-snotify></vue-snotify>
		<menu-float/>
		<EnterpriseName/>
		<div id="app-bottom-padding"></div>
	</div>
</template>

<script>
	import { mapMutations } from "vuex";

	import "@/assets/css/custom-style.css";
	import "@/assets/css/style.css";
	import "@/assets/scss/index.scss";

	import NavBar from "@/components/NavBar.vue";
	import SideBar from "@/components/SideBar.vue";
	import MenuFloat from "@/components/MenuFloat.vue";

	import { copy } from "./helpers/common";
	import { AuthService } from "./services/auth";
	import { validateCPFCNPJ } from "@/helpers/validateIndentity";
	import EnterpriseName from "./components/EnterpriseName.vue";
	import clickOutside from "@/directives/click-outside.js";

	let itensHistorico = 0;

	const isMobile = () => window.innerWidth <= 790;

	export default {
		name: "App",
		components: {
			NavBar,
			SideBar,
			EnterpriseName,
			MenuFloat
		},

		directives: { clickOutside },

		data () {
			return {
				showMenu: false,
				sideBarWidth: 0,
				sideBarHidden: true,
				sideBarMaxWidth: 0,
				initialized: false,
				sideBarOnlyExpanded: true,
				links: [
					{
						to: { name: "home" },
						name: "Dashboard",
						icon: "calendar",
						showPerms: ["DASHBOARD_CALENDARIO_V"]
					},
					{
						to: { name: "agendamentos" },
						name: "Agendamentos",
						icon: "award",
						showPerms: ["SCHEDULING_V"]
					},
					{
						name: "Gerenciamento",
						icon: "editCustom",
						children: [
							{
								to: { name: "gruposUsuarios" },
								name: "Grupos de Usuários",
								icon: "users",
								showPerms: ["GER_V_GRUPO_USUARIO"]
							},
							{
								to: { name: "usuarios" },
								name: "Usuários",
								icon: "user",
								showPerms: ["GER_V_USUARIOS"]
							},
							{
								to: { name: "categoryExpenses" },
								name: "Categorias de Transação",
								icon: "package",
								showPerms: ["GER_V_CATEGORIAS"]
							},
							{
								to: { name: "accountClass" },
								name: "Tipos de Contas",
								icon: "folder",
								showPerms: ["GER_V_TIPOS"]
							},
							{
								to: { name: "account" },
								name: "Contas",
								icon: "fileText",
								showPerms: ["GER_V_CONTAS"]
							}, {
								to: { name: "customer" },
								name: "Clientes",
								icon: "clientesCustom",
								showPerms: ["GER_V_CUSTOMER"]
							}, 									{
								to: { name: "productClass" },
								name: "Categoria Produtos/Serviços",
								icon: "box",
								showPerms: ["GER_V_PRODUTOS"]
							},
							{
								to: { name: "product" },
								name: "Produtos/Serviços",
								icon: "layers",
								showPerms: ["GER_V_PRODUTOS"]
							},
							{
								to: { name: "taxe" },
								name: "Tributos",
								icon: "percent",
								showPerms: ["GER_V_TRIBUTO"]
							}
						]
					},
					{
						name: "Gestão Comercial",
						icon: "briefcase",
						children: [
							{
								to: { name: "sale" },
								name: "Vendas/Serviços",
								icon: "dollarSign",
								showPerms: ["GER_V_VENDA"]
							},
							{
								to: { name: "budget" },
								name: "Orçamentos",
								icon: "edit3",
								showPerms: ["GER_V_ORCAMENTO"]
							}
						]
					},
					{
						to: { name: "transactionsRecord" },
						name: "Transações",
						icon: "transactionsCustom", // "bankCustom",
						showPerms: ["GER_V_AGENDAMENTOS", "GER_V_RECEIVE", "GER_V_RENDAS"]
					},
					{
						name: "Assinaturas",
						icon: "Star",
						children: [
							{
								to: { name: "subscription" },
								name: "Assinaturas",
								icon: "Award",
								showPerms: ["GER_V_ASSINATURAS"]
							},
							{
								to: { name: "subscriptionType" },
								name: "Tipos de Assinatura",
								icon: "folder",
								showPerms: ["GER_V_ASSINATURAS"]
							}
						]
					},
					{
						name: "Relatórios",
						icon: "printer",
						children: [
							{
								to: { name: "accountBalance"},
								name: "Saldo das Contas",
								icon: "fileText",
								showPerms: ["REL_V_CONTAS"]
							},
							{
								to: { name: "chartCategory"},
								name: "Despesas por Categorias",
								icon: "BarChart2",
								showPerms: ["DASHBOARD_V_CHART_CATEGORY"]
							},
							{
								to: { name: "chartAnalysis"},
								name: "Análise Comparativa",
								icon: "LineChart",
								showPerms: ["DASHBOARD_V_CHART_GERAL"]
							},
							{
								to: { name: "chartCategoryToReceive"},
								name: "Receitas por Categorias",
								icon: "BarChart2",
								showPerms: ["DASHBOARD_V_CHART_CATEGORY_INCOME"]
							}
						]
					},
					{
						to: { name: "perfilUsuario" },
						name: "Perfil de Usuário",
						icon: "user"
					},
					{
						to: { name: "about" },
						name: "Sobre",
						icon: "info"
					}
				],
				parsedLinks: [],
				authService: new AuthService(),
				validateCPFCNPJ,
				menuButtonClicked: false
			};
		},

		computed: {
			showBackButton () {
				const routes = ["home"];
				return !routes.includes(this.$route.name);
			},

			noPermission () {
				return [].some((el) => el === this.$route.name);
			}
		},

		watch: {
			noPermission () {
				this.sideBarHidden = this.noPermission;
				this.updateSideBarWidth(
					this.sideBarHidden || isMobile() ? 0 : this.sideBarWidth
				);
			},
			"sideBarMaxWidth" () {
				if (this.sideBarOnlyExpanded) this.sideBarWidth = this.sideBarMaxWidth;
			}
		},

		methods: {
			goBack () {
				if (itensHistorico > 1)
					return this.$router.back();

				let found = false;
				for (let i = this.$route.matched.length - 1; i >= 0; i--) {
					const match = this.$route.matched[i];
					if (match.parent && match.parent.path + "/" !== match.path) {
						itensHistorico--;
						if (match.parent.parent) {
							this.$router.push(match.parent.path);
							found = true;
							break;
						}
					}
				}

				if (!found)
					this.$router.push({ name: "home" });
			},

			toggleSideBar () {
				if (this.noPermission) return;

				this.menuButtonClicked = true;
				this.sideBarHidden = !this.sideBarHidden;
				this.updateSideBarWidth(
					this.sideBarHidden || isMobile() ? 0 : this.sideBarWidth
				);
			},

			sideBarResized (w) {
				this.sideBarWidth = w;
				this.updateSideBarWidth(
					this.sideBarHidden || isMobile() || this.noPermission ? 0 : w
				);
			},

			updateSideBarMaxWidth (w) {
				this.sideBarMaxWidth = w;
				// Detecta celular e encolhe a barra
				if (!this.initialized) {
					if (this.sideBarOnlyExpanded) {
						this.sideBarWidth = w;
					} else {
						this.sideBarWidth = 72;
						this.sideBarHidden = w < 100;
					}
					this.initialized = true;
					this.updateSideBarWidth(
						(this.sideBarHidden || isMobile() || this.noPermission) ? 0 : this.sideBarWidth
					);
				}
			},

			sideBarLinkClicked () {
				if (isMobile())
					this.sideBarHidden = !this.sideBarHidden;
			},

			_updateLinks (links) {
				for (const link of links) {
					if (link.children)
						link.children = this._updateLinks(link.children);
				}

				return links.filter(
					ln => !ln.showPerms || !ln.children || ln.children.length > 0
				);
			},

			updateLinks () {
				const links = copy(this.links);
				this.parsedLinks = this._updateLinks(links);
			},

			...mapMutations(["updateSideBarWidth"]),

			onClickOutside () {
				if (isMobile() && !this.sideBarHidden && !this.menuButtonClicked)
					this.sideBarHidden = !this.sideBarHidden;

				this.menuButtonClicked = false;
			}
		},

		created () {
			this.updateLinks();

			this.$router.afterEach((to, from) => {
				if (from.name === null || to.name === "home")
					itensHistorico = 0;
				else
					itensHistorico++;
			});

			const usuarioLogado = this.authService.getModuleStorage();
			this.$store.commit("initUsuarioLogado", usuarioLogado);
			this.$store.commit("initAccount", null);
			this.$store.commit("initCategory", null);
			this.$store.commit("initCustomer", null);

			this.$validator.extend("noZeroCurrency", {
				validate: (value) => {
					const valueNumber = parseFloat(value.replace(",", "."));
					if (valueNumber <= 0) return false;
					return true;
				}
			});

			this.$validator.extend("validateCPF", {
				validate: (value) => validateCPFCNPJ(value)
			});

			this.$validator.extend("isDate", {
				validate: (value) => {
					const regex = /^([0-2][0-9]|(3)[0-1])-(0[1-9]|1[0-2])-\d{4}$/;
					if (!regex.test(value)) return false;

					const [day, month, year] = value.split("-");
					const date = new Date(year, month - 1, day);
					return date.getDate() == day && date.getMonth() + 1 == month && date.getFullYear() == year;
				}
			});

			this.$validator.extend("notGreaterThan", {
				validate: (value, [max]) => {
					let valueNumber = value = value.replace(/\./g, "");
					valueNumber = parseFloat(value.replace(",", "."));
					const valueMax = parseFloat(max);
					return valueNumber <= valueMax;
				}
			});

			this.$validator.extend("notLessThan", {
				validate: (value, [min]) => {
					let valueNumber = value = value.replace(/\./g, "");
					valueNumber = parseFloat(value.replace(",", "."));
					const valueMin = parseFloat(min);
					return valueNumber > valueMin;
				}
			});

			this.$validator.extend("maxLength", {
				validate: (value, maxLen) => {
					const len = value.length;
					if (len > maxLen) {
						return false;
					}
					return true;
				}
			});

			this.$validator.extend("matchRecordId", {
				validate: (string, obj) => {
					const { text, value } = obj;
					if (text === string && value) return true;

					return false;
				}
			});
		},

		provide () {
			return { parentValidator: this.$parent.$validator };
		}
	};
</script>

<style scoped>
	#app-bottom-padding {
		height: 15px;
	}

	@media (max-width: 790px) {
		#app-bottom-padding {
			max-height: 0px;
		}
	}

	.background-div {
		position: absolute;
		width: 100%;
		height: 100vh;  /* Ajusta según sea necesario */
		overflow: auto !important;
		background-image: url('./assets/img/background.png');
		background-size: cover;  /* Ajusta el tamaño de la imagen */
		background-position: center;  /* Centra la imagen */
		background-repeat: no-repeat;  /* Evita que la imagen se repita */
		overflow-x: hidden !important;
	}
</style>

<style>
	.text-ellipsis {
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow-x: hidden;
	}

	.container {
		max-width: 98%;
	}
</style>
